import React, { useMemo } from "react";
import { ProviderInfoNavWithContext } from "../ProviderInfoNav";
import { ProviderInfoWithContext } from "../ProviderInfo";
import { buildUri, ROUTE, ROUTE_TITLE, tracker } from "../misc";
import { useCategory } from "../hooks";
import { ProviderInfoPageContext } from "../Context";
import { useProviderInfoPage } from "./useProviderInfoPage";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import { ProviderReportWithContext } from "../ProviderReport";
import { CategoryMetaContext } from "../Context/CategoryMetaContext";
import styles from "./ProviderInfoPage.module.scss";

export const ProviderInfoFragment: React.FC<{}> = () => {
    return (
        <>
            <div className="row">
                <ProviderInfoNavWithContext />
            </div>
            <div className="row">
                <ProviderInfoWithContext />
            </div>
            <div className={`row ${styles.providerReport}`}>
                <ProviderReportWithContext />
            </div>
            <div className="row">
                <ProviderInfoNavWithContext />
            </div>
            {/* <div className="row">
                <div className="col-12">
                    <StackHorizontalChartDemo />
                    <SolidDashLineChartDemo />
                </div>
            </div> */}
        </>
    );
};

interface LLProviderInfoPageProps {
    adminId: string;
}
const LLProviderInfoPage: React.FC<LLProviderInfoPageProps> = ({ adminId }) => {
    const { metadata, provider, loading, contextType } = useProviderInfoPage(adminId);

    const locationAdminIds = useMemo(() => {
        return [adminId].filter(d => d != null && d.toString().trim() !== "");
    }, [adminId]);

    const {
        categories,
        roots,
        adminIdToCategory,
        tIdToCategory,
        loading: categoryLoading
    } = useCategory(locationAdminIds, contextType);

    return (
        <ProviderInfoPageContext.Provider
            value={{
                metadata,
                provider,
                loading,
                contextType
            }}
        >
            <CategoryMetaContext.Provider
                value={{
                    categoryLoading,
                    categories,
                    roots,
                    adminIdToCategory,
                    tIdToCategory
                }}
            >
                <ProviderInfoFragment />
            </CategoryMetaContext.Provider>
        </ProviderInfoPageContext.Provider>
    );
};

interface RouteParams {
    id: string;
}

export const ProviderInfoPage: React.FC<{}> = () => {
    const history = useHistory();
    const { search } = useLocation();
    const { id } = useMemo(() => {
        return search == null || search.toString().trim() === ""
            ? ({ id: null } as {
                  id: string;
              })
            : (queryString.parse(search) as {
                  id: string;
              });
    }, [search]);

    if (id == null || id.trim() === "") {
        // alert("redirect");
        history.push(ROUTE.HOME);
        return null;
    }

    document.title = ROUTE_TITLE.PROVIDER_INFO;
    tracker.providerPageNavHistoryIndex = buildUri(
        ROUTE.PROVIDER_INFO,
        {},
        {
            id
        }
    );

    return <LLProviderInfoPage adminId={id} />;
};
